export default {
    playerSearch: '',
    nationalityCode: '',
    customFilters: [],
    decision: '',
    shootsCatches: '',
    draftRound: '',
    draftYear: '',
    isRookie: '',
    homeRoad: '',
    opponent: '',
    birthStateProvinceCode: '',
    status: '',
};
